import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { FloatInput, HeadPage } from "src/componentes";
import TributacaoMensagemCadastroCode from "./TributacaoMensagemCadastro.Code";

const TributacaoMensagemCadastroView = () => {
  const {
    register,
    errors,
    handleSubmit,
    onSubmit,
    loading,
    incluir,
    id,
    onExcluir,
  } = TributacaoMensagemCadastroCode();

  return (
    <Container>
      <HeadPage headText="Mensagem Cadastro">
        {id && !incluir && !loading ? (
          <Dropdown.Item onClick={onExcluir}>Excluir</Dropdown.Item>
        ) : undefined}
      </HeadPage>
      {!loading ? (
        <>
          <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Col xs={12}>
                  <FloatInput
                    label="Mensagem"
                    errorsMessage={errors.mensagem}
                    registerField={register("mensagem")}
                    inputMask="textarea"
                  />
                </Col>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12}>
                <Form.Group>
                  <Form.Check type="checkbox" id="padrao">
                    <Form.Check.Input
                      type="checkbox"
                      {...register("padrao")}
                    />
                    <Form.Check.Label>Padrão</Form.Check.Label>
                  </Form.Check>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </Form>
        </>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </Container>
  );
};

export default TributacaoMensagemCadastroView;
